import type { ProductListItem } from 'app/src/services/welfareportal/companyagreement-api'
import type { AutoCompleteChangeEvent, AutoCompleteProps } from 'primereact/autocomplete'
import { AutoComplete } from 'primereact/autocomplete'
import { Button } from 'primereact/button'
import type { ReactElement } from 'react'
import { useRef } from 'react'

interface FavouriteSearchBarProps {
  autoCompleteSearchText: string | undefined
  suggestions: ProductListItem[] | undefined
  isLoading: boolean
  onSearchTextChange: (text?: string) => void
  onAutoCompleteTextChange: (text: string) => void
  onSearchClick: () => void
  onProductSelect: AutoCompleteProps['onSelect']
  placeholderText: string
}

export function FavouriteSearchBar({
  autoCompleteSearchText,
  suggestions,
  isLoading,
  onAutoCompleteTextChange,
  onSearchClick,
  onProductSelect,
  placeholderText,
}: FavouriteSearchBarProps): ReactElement {
  const autocompleteRef = useRef<AutoComplete>(null)

  return (
    <div className='card p-fluid mb-1 mt-1 flex'>
      <AutoComplete
        value={autoCompleteSearchText}
        inputId='search_autocomplete'
        ref={autocompleteRef}
        onChange={(evt: AutoCompleteChangeEvent) => {
          const newValue = typeof evt.value === 'string' ? evt.value : evt.value?.productName
          onAutoCompleteTextChange(newValue ?? '')
        }}
        completeMethod={(evt) => {
          onAutoCompleteTextChange(evt.query)
        }}
        onKeyPress={(evt) => {
          if (evt.key === 'Enter') {
            onSearchClick()
          }
        }}
        maxLength={100}
        pt={{
          root: {
            className: 'w-[100%] mb-4',
          },
          input: {
            root: {
              className: 'rounded-r-none',
            },
          },
          container: {
            className: 'rounded-r-none',
          },
          inputToken: {
            className: typeof autoCompleteSearchText !== 'undefined' ? 'hidden' : '',
          },
          loadingIcon: {
            className: isLoading ? 'grid' : 'hidden',
          },
        }}
        field='productName'
        onSelect={onProductSelect}
        placeholder={placeholderText}
        itemTemplate={(suggestion: ProductListItem) => (
          <div>
            <div className='line-clamp-1'>{suggestion.productName}</div>
          </div>
        )}
        suggestions={suggestions}
      />

      <div>
        <Button
          icon='pi pi-search'
          pt={{ root: { className: 'rounded-s-none', 'aria-label': 'search-button' } }}
          disabled={typeof autoCompleteSearchText === 'undefined' || isLoading}
          onClick={onSearchClick}
        />
      </div>
    </div>
  )
}
